import { IconButton } from '@material-ui/core';
import ArrowDropDownOutlinedIcon from '@mui/icons-material/ArrowDropDownOutlined';
import ArrowDropUpOutlinedIcon from '@mui/icons-material/ArrowDropUpOutlined';
import ContactSupportOutlinedIcon from '@mui/icons-material/ContactSupportOutlined';
import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';
import { ListItemIcon, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';
import { ReactComponent as MessageIcon } from '../../../../assets/icons/message.svg';
import usePermission from '../../../../hooks/usePermission';
import { Paths } from '../../../../utils/routerUrls';
import { NewMessageModal } from '../../../NewMessage/NewMessageModal.component';
import { useStyles as useNavBarMenuStyles } from '../../NavbarMenu/NavbarMenu.styles';
import { useStyles as useNavBarStyles } from '../Navbar.styles';
import { UserPermission } from '../../../../hooks/usePermission';
import IconWithDot from '../../../IconWithDot/IconWithDot.component';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import { SignalRContext } from '../../../../Context/SignalR.context';
import { CallbackMethodNames } from '../../../../models/signalR.types';
import { mailboxActions } from '../../../../reducers/mailboxReducer/mailboxSlice';
import TooltipOne from '../../../TooltipOne/TooltipOne.component';
import { useTranslation } from 'react-i18next';
import { fill } from '../../../../utils/contrastSvgAttributes';
import useSessionUser from '../../../../hooks/useSessionUser';
import { useLayoutContext } from '../../../../Context/Layout.context';

interface MailMenuProp {
  messageModalIsOpen: (value: boolean) => void;
}

export const MailMenu: React.FC<MailMenuProp> = (props) => {
  const navBarStyles = useNavBarStyles();
  const navBarMenuStyles = useNavBarMenuStyles();
  const dispatch = useDispatch();
  const anyUnreadMessagesFound = useSelector((state: RootState) => state.mailbox.anyUnreadMessagesFound);
  const { user } = useSessionUser();
  const { t } = useTranslation();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const { isAnyDropdownOpen } = useLayoutContext();

  const menuOpen = Boolean(anchorEl);

  const [messageModal, setMessageModal] = useState<{ open: boolean; type: 'standard' | 'helpdesk' }>({
    open: false,
    type: 'standard',
  });

  SignalRContext.useSignalREffect(
    CallbackMethodNames.ReceivedNewMessage,
    (message) => {
      console.log('----------ReceivedNewMessage------------');
      console.log('__________addMessagesToInsert:', [message]);
      dispatch(mailboxActions.addMessagesToInsert({ messages: [message], userId: user.profile.sub }));
    },
    [],
  );

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    isAnyDropdownOpen.current = true;
  };

  const handleClose = () => {
    setAnchorEl(null);
    isAnyDropdownOpen.current = false;
  };

  const handleNewMessage = (type: 'standard' | 'helpdesk') => {
    handleClose();
    props.messageModalIsOpen(true);
    setMessageModal({ open: true, type: type });
  };

  const handleInbox = () => {
    window.open(window.location.origin + Paths.mailbox, '_blank');
  };

  const handleNewMessageDialogClose = () => {
    props.messageModalIsOpen(false);
    setMessageModal({ open: false, type: 'standard' });
  };

  const inMailboxAlready = window.location.href.includes(Paths.mailbox);

  const hasPermissionAdminCommunicationAccess = usePermission(UserPermission.AdminCommunicationAccess);
  const hasPermissionAdminOkeCommunicationAccess = usePermission(UserPermission.AdminOkeCommunicationAccess);
  const hasPermissionExaminerCommunicationAccess = usePermission(UserPermission.ExaminerCommunicationAccess);

  const hasPermissionToCommunicationModule =
    hasPermissionAdminCommunicationAccess ||
    hasPermissionAdminOkeCommunicationAccess ||
    hasPermissionExaminerCommunicationAccess;

  return (
    <>
      <TooltipOne title="Menu wiadomości" placement="top">
        <IconButton
          aria-expanded={menuOpen}
          disableRipple
          onClick={inMailboxAlready ? undefined : handleClick}
          className={navBarStyles.navIcon}
        >
          <IconWithDot dotHidden={!anyUnreadMessagesFound}>
            <MessageIcon fill={fill} width="20px" height="20px" className={navBarStyles.messageIcon} />
          </IconWithDot>
          {!inMailboxAlready && <>{menuOpen ? <ArrowDropUpOutlinedIcon /> : <ArrowDropDownOutlinedIcon />}</>}
        </IconButton>
      </TooltipOne>
      {!inMailboxAlready && hasPermissionToCommunicationModule && (
        <Menu anchorEl={anchorEl} open={menuOpen} onClose={handleClose} className={navBarMenuStyles.sx}>
          <MenuItem disableRipple onClick={() => handleNewMessage('standard')}>
            <ListItemIcon>
              <CreateOutlinedIcon fontSize="small" />
            </ListItemIcon>
            Nowa wiadomość
          </MenuItem>
          <MenuItem disableRipple onClick={() => handleNewMessage('helpdesk')}>
            <ListItemIcon>
              <ContactSupportOutlinedIcon fontSize="small" />
            </ListItemIcon>
            Wiadomość Helpdesk
          </MenuItem>
          <MenuItem disableRipple onClick={handleInbox}>
            <ListItemIcon>
              <InboxOutlinedIcon fontSize="small" />
            </ListItemIcon>
            Skrzynka odbiorcza
          </MenuItem>
        </Menu>
      )}
      <NewMessageModal
        open={messageModal.open}
        type={messageModal.type}
        onClose={handleNewMessageDialogClose}
        onSend={handleNewMessageDialogClose}
      />
    </>
  );
};
